import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Link } from "@reach/router";
import MobileMenuItem from "./MobileMenuItem";
import { cuenta, comprar, misclases, comunidad } from "../../utils";
import logotipoPrimary from "../../assets/rebrand/logotipo-primary.png";
import simboloPrimary from "../../assets/rebrand/simbolo-primary.png";

const MobileMenu = ({ signOut }) => {
  const [display, setDisplay] = useState(false);
  const navRef = useRef(null);
  const [navHeight, setNavHeight] = useState(0);

  useLayoutEffect(() => {
    const measure = () => {
      if (navRef.current) setNavHeight(navRef.current.offsetHeight);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  useEffect(() => {
    document.body.style.overflow = display ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [display]);

  return (
    <>
      <nav
        ref={navRef}
        className="panel-mobile-menu navbar navbar-expand-lg navbar-light bg-light py-2 shadow-sm"
        style={{ position: "relative", zIndex: 2 }}
      >
        <div className="container-fluid d-flex align-items-center">
          <Link
            className="navbar-brand d-flex align-items-center gap-2 mb-0 py-0"
            to="/"
          >
            <img
              src={simboloPrimary}
              alt=""
              aria-hidden
              className="flex-shrink-0 d-block align-self-center"
              style={{ height: "2.5rem", width: "auto", objectFit: "contain" }}
            />
            <img
              src={logotipoPrimary}
              alt="TheBodyMethod"
              className="logo-navbar mb-0 d-block align-self-center"
              style={{
                maxHeight: "2.5rem",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Link>
          <button
            className="navbar-toggler ms-auto"
            type="button"
            onClick={() => setDisplay(!display)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
      </nav>
      <div
        className="bg-light w-100 drawer-menu"
        style={{
          position: "fixed",
          top: navHeight,
          bottom: 0,
          left: display ? 0 : "-100vw",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <ul className="navbar-nav px-3 pt-4 pb-5">
          <MobileMenuItem
            name="Home"
            icon="fa fa-home"
            handle="/mytbm"
            setDisplay={setDisplay}
          />
          <h3 className="ps-2 border-bottom pb-2 mt-3 mb-2">Mis Clases</h3>
          {misclases.map(({ name, href, handle }) => (
            <MobileMenuItem
              key={name}
              name={name}
              href={href}
              handle={handle}
              setDisplay={setDisplay}
            />
          ))}
          <h3 className="ps-2 border-bottom pb-2 mt-3 mb-2">Comprar</h3>
          {comprar.map(({ name, href, handle }) => (
            <MobileMenuItem
              key={name}
              name={name}
              href={href}
              handle={handle}
              setDisplay={setDisplay}
            />
          ))}
          <h3 className="ps-2 border-bottom pb-2 mt-3 mb-2">Comunidad</h3>
          {comunidad.map(({ name, href, handle }) => (
            <MobileMenuItem
              key={name}
              name={name}
              href={href}
              handle={handle}
              setDisplay={setDisplay}
            />
          ))}
          <h3 className="ps-2 border-bottom pb-2 mt-3 mb-2">Mi Cuenta</h3>
          {cuenta.map(({ name, handle }) => (
            <MobileMenuItem
              key={name}
              name={name}
              handle={handle}
              setDisplay={setDisplay}
            />
          ))}
          <li className="nav-item mobile mt-5">
            <button
              className="btn btn-link nav-link text-danger"
              onClick={signOut}
            >
              <i className="fa fa-sign-out-alt fa-flip-horizontal ps-2"></i>{" "}
              Salir
            </button>
          </li>
        </ul>
      </div>
    </>
  );
};

export default MobileMenu;
